"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DividedContainer = _interopRequireDefault(require("./DividedContainer.style"));
var _Paragraph = _interopRequireDefault(require("./Paragraph"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var DividedContainer = function DividedContainer(_ref) {
  var title = _ref.title,
    isTimeVisible = _ref.isTimeVisible,
    headerLabel = _ref.headerLabel,
    leftChildren = _ref.leftChildren,
    rightChildren = _ref.rightChildren,
    withBorder = _ref.withBorder,
    leftWidth = _ref.leftWidth,
    rightWidth = _ref.rightWidth,
    mobileOnTop = _ref.mobileOnTop,
    separatorColor = _ref.separatorColor,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_DividedContainer["default"], {
    className: "divided-container ".concat(className),
    "data-testid": className,
    withBorder: withBorder,
    leftWidth: leftWidth,
    rightWidth: rightWidth,
    mobileOnTop: mobileOnTop,
    separatorColor: separatorColor
  }, title && /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
    className: "container-title"
  }, title), isTimeVisible && headerLabel, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-left ".concat(mobileOnTop === 'left' ? 'with-separator' : '')
  }, leftChildren), /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-right ".concat(mobileOnTop === 'right' ? 'with-separator' : '')
  }, rightChildren));
};
DividedContainer.propTypes = {
  title: _propTypes["default"].string,
  headerLabel: _propTypes["default"].node,
  isTimeVisible: _propTypes["default"].bool,
  leftChildren: _propTypes["default"].node.isRequired,
  rightChildren: _propTypes["default"].node.isRequired,
  leftWidth: _propTypes["default"].string,
  rightWidth: _propTypes["default"].string,
  withBorder: _propTypes["default"].bool,
  mobileOnTop: _propTypes["default"].oneOf(['left', 'right']),
  separatorColor: _propTypes["default"].string,
  className: _propTypes["default"].string
};
DividedContainer.defaultProps = {
  title: '',
  headerLabel: '',
  isTimeVisible: false,
  withBorder: false,
  leftWidth: '',
  rightWidth: '',
  mobileOnTop: 'left',
  separatorColor: '',
  className: ''
};
DividedContainer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DividedContainer",
  "props": {
    "title": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "headerLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "isTimeVisible": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "withBorder": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "leftWidth": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "rightWidth": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "mobileOnTop": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'left'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }]
      },
      "required": false
    },
    "separatorColor": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "leftChildren": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "rightChildren": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    }
  }
};
var _default = DividedContainer;
exports["default"] = _default;